// import React, { useEffect, useState } from "react";
// import { Table, Button, Modal, Card, Form, Spinner, Row, Col, InputGroup } from "react-bootstrap";
// import { IconBrandVisa, IconCreditCard } from "@tabler/icons-react";
// import usePostRequest from "../../../hooks/usePostRequest";
// import { API_ENDPOINTS } from "../../../constant/_constant";
// import moment from "moment";
// import { toast } from "react-toastify";
// import OtpVerficationPopup from "./OtpVerificationPopup";
// import { useSelector } from "react-redux";
// import ComanConfirmationModal from "../../../components/ComanConfirmationModal";
// import OtpVerifyPopup from "../../customer/OtpVerifyPopup";
// import CustomerCardEdit from "../../customer/CustomerCardEdit";

// function CardDetails({
//   show,
//   onClose,
//   emailId,
//   paymentAmount,
//   opportunityId,
//   onOtpVerified,
// }) {
//   const [cardDetails, setCardDetails] = useState([]);
//   const [showOtpPopup, setShowOtpPopup] = useState(false);
//   const [paymentData, setPaymentData] = useState(null);
//   const [getCard, setGetCard] = useState(true);
//   const [addCard, setAddCard] = useState(false);
//   const [showCardDetails, setShowCardDetails] = useState(false);
//   const [verifiedCardData, setVerifiedCardData] = useState(null);
//   const [showEditOptPopup, setShowEditOptPopup] = useState(false);

//   const [isModalOpen, setIsModalOpen] = useState({
//     show: false,
//     action: null,
//     message: "",
//   });

//   // Get Card state
//   const [getCardDetails, setGetCardDetails] = useState({ email: "" });
//   const [getCardErrors, setGetCardErrors] = useState({ email: "" });

//   // Add Card state
//   const [addCardData, setAddCardData] = useState({
//     cardHolderName: "",
//     cardNumber: "",
//     expiry: "",
//     cvc: "",
//     address: "",
//   });
//   const [addCardErrors, setAddCardErrors] = useState({
//     cardHolderName: "",
//     cardNumber: "",
//     expiry: "",
//     cvc: "",
//     address: "",
//   });

//   const { postData: fetchReview } = usePostRequest(
//     API_ENDPOINTS.GET_CUSTOMER_CARD
//   );
//   const { postData: sendPaymentOtp } = usePostRequest(
//     API_ENDPOINTS.PAYMENT_OTP
//   );
//   const { isLoading: isLoadingGetCard, postData: postGetCard } = usePostRequest(
//     API_ENDPOINTS.VERIFY_CUSTOMER_EMAIL
//   );
//   const { isLoading: isLoadingAddCard, postData: postAddCard } = usePostRequest(
//     API_ENDPOINTS.CREATE_CARD_INFO
//   );

//   const {
//     isLoading: Verifying,
//     postData: VerifyCustomerOtp,
//     data: Verified,
//   } = usePostRequest(API_ENDPOINTS.SEND_OTP_CARDS);

//   const user = useSelector((state) => state.auth.user);
//   const canEditCards = user?.permissions?.manage_cards?.includes("write");

//   // Fetch card details when modal opens
//   useEffect(() => {
//     if (show) {
//       fetchReview(
//         { email: emailId, other_id: opportunityId },
//         onSuccess,
//         onError
//       );
//       setGetCardDetails({ email: emailId });
//     } else {
//       setCardDetails([]);
//     }
//   }, [show]);

//   const handleOtpVerified = (response) => {
//     console.log("OTP Verified → CardDetails:", response);
//     if (onOtpVerified) {
//       onOtpVerified(response);
//     }
//   };

//   const onSuccess = (response) => setCardDetails(response?.data || []);
//   const onError = (error) =>
//     toast.error(error?.message || "No valid card details found. Please add card details first.");

//   // Validation functions
//   const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
//   const validateCardHolderName = (value) => /^[A-Za-z\s]+$/.test(value);
//   const validateCardNumber = (value) => /^[0-9]{15,16}$/.test(value);
//   const validateExpiry = (value) => /^(0[1-9]|1[0-2])\/\d{2}$/.test(value);
//   const validateCVC = (value) => /^\d{3}$/.test(value);

//   // Get Card handlers
//   const handleGetCardChange = (e) => {
//     const { name, value } = e.target;
//     let error = "";

//     if (value.trim() === "") {
//       error = `${name} is required`;
//     } else if (name === "email" && !validateEmail(value)) {
//       error = "Invalid email address";
//     }

//     setGetCardDetails({ ...getCardDetails, [name]: value });
//     setGetCardErrors({ ...getCardErrors, [name]: error });
//   };

//   const handleGetCardSubmit = (e) => {
//     e.preventDefault();
//     const isValid =
//       getCardDetails.email.trim() !== "" && getCardErrors.email === "";

//     if (!isValid) {
//       toast.error("Please correct the email before submitting");
//       return;
//     }

//     const payload = {
//       other_id: opportunityId,
//       email: getCardDetails.email,
//     };

//     postGetCard(
//       payload,
//       (res) => {
//         toast.success(res?.message || "Card linked successfully");
//         fetchReview(
//           { email: emailId, other_id: opportunityId },
//           onSuccess,
//           onError
//         );
//         setGetCard(false);
//         setGetCardDetails({ email: emailId });
//         setGetCardErrors({ email: "" });
//       },
//       (err) => toast.error(err?.message || "Failed to generate link for card")
//     );
//   };

//   // Add Card handlers
//   const handleAddCardChange = (e) => {
//     const { name, value } = e.target;
//     let validationError = "";
//     let formattedValue = value.replace(/\D/g, "");

//     if (value.trim() === "") {
//       validationError = `${name} is required`;
//     }

//     if (name === "cardNumber") {
//       if (formattedValue.length > 16) {
//         formattedValue = formattedValue.slice(0, 16);
//       }
//       formattedValue = formattedValue.replace(/(.{4})(?=.)/g, "$1 ");

//       if (!validateCardNumber(formattedValue.replace(/\D/g, ""))) {
//         validationError = "Card number must be 15 or 16 digits";
//       }
//     }

//     if (name === "expiry") {
//       if (formattedValue.length >= 3) {
//         formattedValue =
//           formattedValue.slice(0, 2) + "/" + formattedValue.slice(2, 4);
//       }

//       if (!validateExpiry(formattedValue)) {
//         validationError = "Expiry must be in MM/YY format";
//       }
//     }

//     if (name === "cvc") {
//       formattedValue = formattedValue.slice(0, 3);
//       if (formattedValue && !validateCVC(formattedValue)) {
//         validationError = "CVC must be 3 digits";
//       }
//       // if (!validateCVC(formattedValue)) {
//       //   validationError = "CVC must be 3 digits";
//       // }
//     }

//     if (name === "address") {
//       formattedValue = value;
//       validationError = ""; // optional field, no validation
//     }

//     if (name === "cardHolderName") {
//       if (!validateCardHolderName(value)) {
//         validationError = "Cardholder name can only contain letters";
//       }
//       formattedValue = value;
//     }

//     setAddCardData({
//       ...addCardData,
//       [name]: formattedValue,
//     });

//     setAddCardErrors({
//       ...addCardErrors,
//       [name]: validationError,
//     });
//   };

//   const handleAddCardSubmit = (e) => {
//     e.preventDefault();

//     // const formIsValid =
//     //   Object.values(addCardErrors).every((error) => error === "") &&
//     //   Object.values(addCardData).every((value) => value.trim() !== "");

//     const formIsValid =
//       Object.values(addCardErrors).every((error) => error === "") &&
//       addCardData.cardHolderName.trim() !== "" &&
//       addCardData.cardNumber.trim() !== "" &&
//       addCardData.expiry.trim() !== "";

//     if (!formIsValid) {
//       toast.error("Please fix all errors before submitting");
//       return;
//     }

//     const payload = {
//       auto_id: opportunityId,
//       info_number: addCardData.cardNumber.replace(/\s+/g, ""),
//       info_expiry: addCardData.expiry,
//       info_name: addCardData.cardHolderName,
//       cvc_code: addCardData.cvc,
//       address: addCardData.address,
//       type: "opportunity",
//     };

//     postAddCard(
//       payload,
//       (res) => {
//         toast.success(res?.message || "Card added successfully");
//         fetchReview(
//           { email: emailId, other_id: opportunityId },
//           onSuccess,
//           onError
//         );
//         setAddCard(false);
//         setAddCardData({
//           cardHolderName: "",
//           cardNumber: "",
//           expiry: "",
//           cvc: "",
//           address: "",
//         });
//         setAddCardErrors({
//           cardHolderName: "",
//           cardNumber: "",
//           expiry: "",
//           cvc: "",
//           address: "",
//         });
//       },
//       (err) => toast.error(err?.message || "Failed to add card")
//     );
//   };

//   const handleCancel = () => {
//     setGetCard(false);
//     setAddCard(false);
//     setGetCardDetails({ email: emailId });
//     setGetCardErrors({ email: "" });
//     setAddCardData({
//       cardHolderName: "",
//       cardNumber: "",
//       expiry: "",
//       cvc: "",
//       address: "",
//     });
//     setAddCardErrors({
//       cardHolderName: "",
//       cardNumber: "",
//       expiry: "",
//       cvc: "",
//       address: "",
//     });
//   };

//   const onOtpSuccess = (res) => {
//     toast.success(res?.message || "OTP sent successfully");
//     setShowOtpPopup(true);
//     onClose();
//   };

//   const onOtpError = (err) =>
//     toast.error(err?.message || "Failed to initiate payment OTP");

//   const handleOtp = (cardInfo) => {
//     setPaymentData(cardInfo);
//     sendPaymentOtp(
//       { id: cardInfo?.id, type: "rfq_payment" },
//       onOtpSuccess,
//       onOtpError
//     );
//   };

//   const openModal = (id) => {
//     let modalMessage =
//       "Are you sure you want to view/edit customer's card details? An OTP will be sent for verification if you proceed.";
//     let modalTitle = "Edit Customer Card Details";
//     let type = "info";
//     let modalIcon = <IconCreditCard />;
//     let action = "success";

//     const handleSendOtp = () => {
//       VerifyCustomerOtp({ id }, onSuccessVerify, onErrorVerify);
//       setIsModalOpen({ ...isModalOpen, show: false });
//       onClose();
//     };

//     setIsModalOpen({
//       show: true,
//       action,
//       message: modalMessage,
//       onConfirm: handleSendOtp,
//       title: modalTitle,
//       icon: modalIcon,
//       type,
//     });
//   };

//   const onSuccessVerify = (res) => {
//     toast.success(res?.message);
//     // GetPackigSlip({ order_id: orderId });
//     setShowEditOptPopup(true);
//   };

//   const onErrorVerify = (err) => {
//     toast.error(err?.message || "Failed to delete record");
//   };

//   const handleOtpVerifiedEdit = (verifiedResponse) => {
//     setVerifiedCardData(verifiedResponse);
//     setShowEditOptPopup(false);
//     setShowCardDetails(true);
//   };

//   return (
//     <>

//       {showCardDetails && (
//         <CustomerCardEdit
//           show={showCardDetails}
//           onClose={() => setShowCardDetails(false)}
//           formData={verifiedCardData}
//         />
//       )}

//       <ComanConfirmationModal
//         show={isModalOpen.show}
//         onHide={() => setIsModalOpen({ ...isModalOpen, show: false })}
//         title={isModalOpen.title}
//         message={isModalOpen.message}
//         onConfirm={isModalOpen.onConfirm}
//         icon={isModalOpen.icon}
//         type={isModalOpen.type}
//       />

//       {showEditOptPopup && (
//         <OtpVerifyPopup
//           show={showEditOptPopup}
//           onClose={() => setShowEditOptPopup(false)}
//           formData={Verified}
//           onVerified={handleOtpVerifiedEdit}
//         />
//       )}

//       {showOtpPopup && (
//         <OtpVerficationPopup
//           show={showOtpPopup}
//           onClose={() => setShowOtpPopup(false)}
//           formData={paymentData}
//           paymentAmount={paymentAmount}
//           opportunityId={opportunityId}
//           onVerified={(response) => {
//             handleOtpVerified();
//             setShowOtpPopup(false);
//             if (window.onPaymentSuccess) {
//               window.onPaymentSuccess(response);
//             }
//           }}
//         />
//       )}

//       <Modal show={show} onHide={onClose} size="xl">
//         <Modal.Header className="gap-2 justify-content-between pe-5" closeButton>
//           <div className="d-flex align-items-center gap-2">
//             <span className="avatar bg-indigo-lt rounded-circle">
//               <IconCreditCard />
//             </span>
//             <Modal.Title>Card Details</Modal.Title>
//           </div>
//           <div className="d-flex gap-2">
//             <span
//               className="add_new_card bg-indigo"
//               variant="outline-primary"
//               size="sm"
//               onClick={() => {
//                 setAddCard(!addCard);
//                 setGetCard(false);
//               }}
//             >
//               {addCard ? "Hide" : "Add Card"}
//             </span>
//             <span
//               className="add_new_card bg-indigo"
//               variant="outline-primary"
//               size="sm"
//               onClick={() => {
//                 setGetCard(!getCard);
//                 setAddCard(false);
//               }}
//             >
//               {getCard ? "Hide" : "Get Card"}
//             </span>
//           </div>
//         </Modal.Header>

//         <Modal.Body>
//           <div className="table-responsive mail_wrapper p-0 border-0 mb-0 box-shadow-none">
//             <Table className="table-bordered card-table">
//               <thead>
//                 <tr>
//                   <th>CARDHOLDER NAME</th>
//                   <th>CARD NUMBER</th>
//                   <th>CARD EXPIRY</th>
//                   <th>INVOICE NUMBER</th>
//                   <th>CREATED DATE</th>
//                   <th>ACTIONS</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {cardDetails.length === 0 ? (
//                   <tr>
//                     <td colSpan="6" className="text-center">
//                       No card details found.
//                     </td>
//                   </tr>
//                 ) : (
//                   cardDetails.map((card) => (
//                     <>
//                       <tr key={card.id}>
//                         <td>{card.info_name}</td>
//                         <td>{"**** **** **** " + card.info_number}</td>
//                         <td>{card.info_expiry}</td>
//                         <td>{card.invoice_number || "N/A"}</td>
//                         <td>{moment(card.created_at).format("MM/DD/YYYY")}</td>
//                         <td className="d-flex gap-2">
//                           <Button
//                             className="w-auto"
//                             style={{ minWidth: "auto" }}
//                             onClick={() => handleOtp(card)}
//                           >
//                             Pay
//                           </Button>
//                           <Button
//                             className="w-auto"
//                             style={{ minWidth: "auto" }}
//                             onClick={() => openModal(card?.id)}
//                             disabled={!canEditCards}
//                           >
//                             View/Edit
//                           </Button>
//                         </td>
//                       </tr>
//                       <tr key={`note-${card.id}`}>
//                         <td colSpan="6" className="text-end">
//                           Notes: {card.note || "N/A"}
//                         </td>
//                       </tr>
//                     </>
//                   ))
//                 )}
//               </tbody>
//             </Table>
//           </div>

//           {/* Get Card Section */}
//           {getCard && (
//             <Card className="add_credit_card mb-3 mt-3">
//               <Card.Header className="card_header">GET NEW CARD</Card.Header>
//               <Card.Body>
//                 <Form onSubmit={handleGetCardSubmit}>
//                   <Form.Group className="mb-3">
//                     <Form.Label className="required">EMAIL</Form.Label>
//                     <Form.Control
//                       type="email"
//                       name="email"
//                       value={getCardDetails.email}
//                       onChange={handleGetCardChange}
//                       placeholder="Enter your email address"
//                     />
//                     {getCardErrors.email && (
//                       <div className="text-danger">{getCardErrors.email}</div>
//                     )}
//                   </Form.Group>

//                   <div className="d-flex justify-content-center gap-2">
//                     <Button
//                       type="submit"
//                       variant="primary"
//                       disabled={
//                         isLoadingGetCard ||
//                         getCardDetails.email.trim() === "" ||
//                         getCardErrors.email
//                       }
//                     >
//                       {isLoadingGetCard ? (
//                         <Spinner
//                           as="span"
//                           animation="border"
//                           size="sm"
//                           role="status"
//                           aria-hidden="true"
//                         />
//                       ) : (
//                         "Get Card"
//                       )}
//                     </Button>
//                     <Button
//                       type="button"
//                       variant="outline-secondary"
//                       onClick={handleCancel}
//                     >
//                       Cancel
//                     </Button>
//                   </div>
//                 </Form>
//               </Card.Body>
//             </Card>
//           )}

//           {/* Add Card Section */}
//           {addCard && (
//             <Card className="add_credit_card mb-3 mt-3">
//               <Card.Header className="card_header">ADD NEW CARD</Card.Header>
//               <Card.Body>
//                 <Form onSubmit={handleAddCardSubmit}>
//                   <Row>
//                     <Col md={12}>
//                       <Form.Group className="mb-3">
//                         <Form.Label className="required">
//                           CARDHOLDER NAME
//                         </Form.Label>
//                         <InputGroup>
//                           <Form.Control
//                             name="cardHolderName"
//                             value={addCardData.cardHolderName}
//                             onChange={handleAddCardChange}
//                             placeholder="Enter Cardholder Name"
//                           />
//                         </InputGroup>
//                         {addCardErrors.cardHolderName && (
//                           <div className="text-danger">
//                             {addCardErrors.cardHolderName}
//                           </div>
//                         )}
//                       </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                       <Form.Group className="mb-3">
//                         <Form.Label className="required">CARD NUMBER</Form.Label>
//                         <InputGroup>
//                           <InputGroup.Text>
//                             <IconBrandVisa stroke={1} />
//                           </InputGroup.Text>
//                           <Form.Control
//                             name="cardNumber"
//                             value={addCardData.cardNumber}
//                             onChange={handleAddCardChange}
//                             type="text"
//                             placeholder="**** **** **** ****"
//                           />
//                         </InputGroup>
//                         {addCardErrors.cardNumber && (
//                           <div className="text-danger">
//                             {addCardErrors.cardNumber}
//                           </div>
//                         )}
//                       </Form.Group>
//                     </Col>
//                     <Col md={3}>
//                       <Form.Group className="mb-3">
//                         <Form.Label className="required">EXPIRY</Form.Label>
//                         <InputGroup>
//                           <Form.Control
//                             name="expiry"
//                             value={addCardData.expiry}
//                             onChange={handleAddCardChange}
//                             type="text"
//                             placeholder="MM/YY"
//                             maxLength={5}
//                           />
//                         </InputGroup>
//                         {addCardErrors.expiry && (
//                           <div className="text-danger">
//                             {addCardErrors.expiry}
//                           </div>
//                         )}
//                       </Form.Group>
//                     </Col>
//                     <Col md={3}>
//                       <Form.Group className="mb-3">
//                         <Form.Label className="">CVC CODE</Form.Label>
//                         <InputGroup>
//                           <Form.Control
//                             name="cvc"
//                             value={addCardData.cvc}
//                             onChange={handleAddCardChange}
//                             type="password"
//                             maxLength={3}
//                             placeholder="123"
//                           />
//                         </InputGroup>
//                         {addCardErrors.cvc && (
//                           <div className="text-danger">{addCardErrors.cvc}</div>
//                         )}
//                       </Form.Group>
//                     </Col>
//                     <Col md={12}>
//                       <Form.Group className="mb-3">
//                         <Form.Label>ADDRESS</Form.Label>
//                         <InputGroup>
//                           <Form.Control
//                             name="address"
//                             value={addCardData.address}
//                             onChange={handleAddCardChange}
//                             placeholder="Enter Address"
//                           />
//                         </InputGroup>
//                       </Form.Group>
//                     </Col>
//                   </Row>
//                   <div className="d-flex justify-content-center gap-2">
//                     <Button
//                       type="submit"
//                       variant="warning"
//                       disabled={
//                         isLoadingAddCard ||
//                         Object.values(addCardErrors).some(
//                           (error) => error !== ""
//                         ) ||
//                         addCardData.cardHolderName.trim() === "" ||
//                         addCardData.cardNumber.trim() === "" ||
//                         addCardData.expiry.trim() === ""
//                         // Object.values(addCardData).some(
//                         //   (value) => value.trim() === ""
//                         // )
//                       }
//                     >
//                       {isLoadingAddCard ? (
//                         <Spinner
//                           as="span"
//                           animation="border"
//                           size="sm"
//                           role="status"
//                           aria-hidden="true"
//                         />
//                       ) : (
//                         "Submit"
//                       )}
//                     </Button>
//                     <Button
//                       type="button"
//                       variant="outline-secondary"
//                       onClick={handleCancel}
//                     >
//                       Cancel
//                     </Button>
//                   </div>
//                 </Form>
//               </Card.Body>
//             </Card>
//           )}
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// }

// export default CardDetails;

import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Card,
  Form,
  Spinner,
  Row,
  Col,
  InputGroup,
} from "react-bootstrap";
import {
  IconBrandVisa,
  IconCreditCard,
  IconCurrencyDollar,
} from "@tabler/icons-react";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../../constant/_constant";
import moment from "moment";
import { toast } from "react-toastify";
import OtpVerficationPopup from "./OtpVerificationPopup";
import { useSelector } from "react-redux";
import ComanConfirmationModal from "../../../components/ComanConfirmationModal";
import OtpVerifyPopup from "../../customer/OtpVerifyPopup";
import CustomerCardEdit from "../../customer/CustomerCardEdit";
import { usePostHog } from "@posthog/react";

function CardDetails({
  show,
  onClose,
  emailId,
  paymentAmount,
  opportunityId,
  onOtpVerified,
  invoiceNo,
}) {
  const [cardDetails, setCardDetails] = useState([]);
  const [showOtpPopup, setShowOtpPopup] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const [getCard, setGetCard] = useState(true);
  const [addCard, setAddCard] = useState(false);
  const [showCardDetails, setShowCardDetails] = useState(false);
  const [verifiedCardData, setVerifiedCardData] = useState(null);
  const [showEditOptPopup, setShowEditOptPopup] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  // Get Card state
  const [getCardDetails, setGetCardDetails] = useState({ email: "" });
  const [getCardErrors, setGetCardErrors] = useState({ email: "" });

  // Add Card state
  const [addCardData, setAddCardData] = useState({
    cardHolderName: "",
    cardNumber: "",
    expiry: "",
    cvc: "",
    address: "",
    zipCode: "",
    invoiceNumber: "",
    amount: "",
    notes: "",
  });
  const [addCardErrors, setAddCardErrors] = useState({
    cardHolderName: "",
    cardNumber: "",
    expiry: "",
    cvc: "",
    address: "",
    zipCode: "",
    invoiceNumber: "",
    amount: "",
    notes: "",
  });

  const { postData: fetchReview } = usePostRequest(
    API_ENDPOINTS.GET_CUSTOMER_CARD,
  );
  const { postData: sendPaymentOtp } = usePostRequest(
    API_ENDPOINTS.PAYMENT_OTP,
  );
  const { isLoading: isLoadingGetCard, postData: postGetCard } = usePostRequest(
    API_ENDPOINTS.VERIFY_CUSTOMER_EMAIL,
  );
  const { isLoading: isLoadingAddCard, postData: postAddCard } = usePostRequest(
    API_ENDPOINTS.CREATE_CARD_INFO,
  );

  const {
    isLoading: Verifying,
    postData: VerifyCustomerOtp,
    data: Verified,
  } = usePostRequest(API_ENDPOINTS.SEND_OTP_CARDS);

  const user = useSelector((state) => state.auth.user);
  const canEditCards = user?.permissions?.manage_cards?.includes("write");
  const posthog = usePostHog();

  // Fetch card details when modal opens
  useEffect(() => {
    if (show) {
      fetchReview(
        { email: emailId, other_id: opportunityId, type: "RFQ" },
        onSuccess,
        onError,
      );
      setGetCardDetails({ email: emailId });
      // Pre-populate disabled fields from props so submit validation passes
      setAddCardData((prev) => ({
        ...prev,
        invoiceNumber: invoiceNo || prev.invoiceNumber,
        amount: paymentAmount || prev.amount,
      }));
    } else {
      setCardDetails([]);
    }
  }, [show]);

  const handleOtpVerified = (response) => {
    console.log("OTP Verified → CardDetails:", response);
    if (onOtpVerified) {
      onOtpVerified(response);
    }
  };

  const onSuccess = (response) => setCardDetails(response?.data || []);
  const onError = (error) => console.log(error);
  // toast.error(error?.message || "No valid card details found. Please add card details first.");

  // Validation functions
  const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  const validateCardHolderName = (value) => /^[A-Za-z\s]+$/.test(value);
  const validateCardNumber = (value) => /^[0-9]{15,16}$/.test(value);
  const validateExpiry = (value) => {
    if (!/^(0[1-9]|1[0-2])\/\d{2}$/.test(value)) return false;
    const month = parseInt(value.slice(0, 2), 10);
    return month >= 1 && month <= 12;
  };
  const validateCVC = (value) => /^\d{3,4}$/.test(value);
  const validateZipCode = (value) => /^\d{5,9}$/.test(value);
  const validateAmount = (value) => !isNaN(value) && parseFloat(value) > 0;

  // Get Card handlers
  const handleGetCardChange = (e) => {
    const { name, value } = e.target;
    let error = "";

    if (value.trim() === "") {
      error = `${name} is required`;
    } else if (name === "email" && !validateEmail(value)) {
      error = "Invalid email address";
    }

    setGetCardDetails({ ...getCardDetails, [name]: value });
    setGetCardErrors({ ...getCardErrors, [name]: error });
  };

  const handleGetCardSubmit = (e) => {
    e.preventDefault();
    const isValid =
      getCardDetails.email.trim() !== "" && getCardErrors.email === "";

    if (!isValid) {
      toast.error("Please correct the email before submitting");
      return;
    }

    const payload = {
      other_id: opportunityId,
      email: getCardDetails.email,
    };

    postGetCard(
      payload,
      (res) => {
        toast.success(res?.message || "Card linked successfully");
        fetchReview(
          { email: emailId, other_id: opportunityId, type: "RFQ" },
          onSuccess,
          onError,
        );
        setGetCard(false);
        setGetCardDetails({ email: emailId });
        setGetCardErrors({ email: "" });
      },
      (err) => toast.error(err?.message || "Failed to generate link for card"),
    );
  };

  // Add Card handlers
  const handleAddCardChange = (e) => {
    const { name, value } = e.target;
    let validationError = "";
    let formattedValue = value;

    switch (name) {
      case "cardNumber": {
        const digits = value.replace(/\D/g, "").slice(0, 16);
        formattedValue = digits.replace(/(.{4})(?=.)/g, "$1 ");
        if (digits.trim() === "") validationError = "Card number is required";
        else if (!validateCardNumber(digits))
          validationError = "Card number must be 15 or 16 digits";
        break;
      }

      case "expiry": {
        const digits = value.replace(/\D/g, "").slice(0, 4);
        formattedValue =
          digits.length >= 3
            ? `${digits.slice(0, 2)}/${digits.slice(2)}`
            : digits;
        if (formattedValue.trim() === "")
          validationError = "Expiry is required";
        else if (!validateExpiry(formattedValue))
          validationError =
            "Expiry must be in MM/YY format with a valid month (01–12)";
        break;
      }

      case "cvc": {
        formattedValue = value.replace(/\D/g, "").slice(0, 4);
        if (formattedValue && !validateCVC(formattedValue))
          validationError = "CVC must be 3 or 4 digits";
        break;
      }

      case "zipCode": {
        formattedValue = value.replace(/\D/g, "").slice(0, 9);
        if (formattedValue.trim() === "")
          validationError = "ZIP Code is required";
        else if (!validateZipCode(formattedValue))
          validationError = "ZIP code must be 5–9 digits";
        break;
      }

      case "invoiceNumber": {
        if (value.trim() === "") validationError = "Invoice number is required";
        break;
      }

      case "amount": {
        if (value.trim() === "") validationError = "Amount is required";
        else if (!validateAmount(value))
          validationError = "Amount must be a positive number";
        break;
      }

      case "cardHolderName": {
        if (value.trim() === "")
          validationError = "Cardholder name is required";
        else if (!validateCardHolderName(value))
          validationError =
            "Cardholder name can only contain letters and spaces";
        break;
      }

      // address and notes: optional, no validation
      default:
        break;
    }

    setAddCardData({ ...addCardData, [name]: formattedValue });
    setAddCardErrors({ ...addCardErrors, [name]: validationError });
  };

  const handleAddCardSubmit = (e) => {
    e.preventDefault();

    const requiredFields = {
      cardHolderName: "Cardholder name is required",
      cardNumber: "Card number is required",
      expiry: "Expiry is required",
      zipCode: "ZIP Code is required",
      invoiceNumber: "Invoice number is required",
      amount: "Amount is required",
    };

    const newErrors = { ...addCardErrors };
    let hasError = false;

    Object.entries(requiredFields).forEach(([field, msg]) => {
      if (!addCardData[field] || addCardData[field].toString().trim() === "") {
        newErrors[field] = msg;
        hasError = true;
      }
    });

    setAddCardErrors(newErrors);

    const existingErrors = Object.values(newErrors).some((err) => err !== "");
    if (hasError || existingErrors) {
      toast.error("Please fix all errors before submitting");
      return;
    }

    const payload = {
      auto_id: opportunityId,
      info_number: addCardData.cardNumber.replace(/\s+/g, ""),
      info_expiry: addCardData.expiry.replace("/", ""),
      info_name: addCardData.cardHolderName,
      cvc_code: addCardData.cvc || null,
      address: addCardData.address || null,
      zip_code: addCardData.zipCode,
      invoice_number: addCardData.invoiceNumber,
      amount: addCardData.amount,
      note: addCardData.notes || null,
      type: "opportunity",
    };

    postAddCard(
      payload,
      (res) => {
        toast.success(res?.message || "Card added successfully");
        posthog.capture("payment_details_added", {
          created_by: user?.email,
        });
        fetchReview(
          { email: emailId, other_id: opportunityId, type: "RFQ" },
          onSuccess,
          onError,
        );
        setAddCard(false);
        setAddCardData({
          cardHolderName: "",
          cardNumber: "",
          expiry: "",
          cvc: "",
          address: "",
          zipCode: "",
          invoiceNumber: invoiceNo || "",
          amount: paymentAmount || "",
          notes: "",
        });
        setAddCardErrors({
          cardHolderName: "",
          cardNumber: "",
          expiry: "",
          cvc: "",
          address: "",
          zipCode: "",
          invoiceNumber: "",
          amount: "",
          notes: "",
        });
      },
      (err) => toast.error(err?.message || "Failed to add card"),
    );
  };

  const handleCancel = () => {
    setGetCard(false);
    setAddCard(false);
    setGetCardDetails({ email: emailId });
    setGetCardErrors({ email: "" });
    setAddCardData({
      cardHolderName: "",
      cardNumber: "",
      expiry: "",
      cvc: "",
      address: "",
      zipCode: "",
      invoiceNumber: invoiceNo || "",
      amount: paymentAmount || "",
      notes: "",
    });
    setAddCardErrors({
      cardHolderName: "",
      cardNumber: "",
      expiry: "",
      cvc: "",
      address: "",
      zipCode: "",
      invoiceNumber: "",
      amount: "",
      notes: "",
    });
  };

  const onOtpSuccess = (res) => {
    toast.success(res?.message || "OTP sent successfully");
    setShowOtpPopup(true);
    onClose();
  };

  const onOtpError = (err) =>
    toast.error(err?.message || "Failed to initiate payment OTP");

  const handleOtp = (cardInfo) => {
    setPaymentData(cardInfo);
    sendPaymentOtp(
      { id: cardInfo?.id, type: "rfq_payment" },
      onOtpSuccess,
      onOtpError,
    );
  };

  const openModal = (id) => {
    let modalMessage =
      "Are you sure you want to view/edit customer's card details? An OTP will be sent for verification if you proceed.";
    let modalTitle = "Edit Customer Card Details";
    let type = "info";
    let modalIcon = <IconCreditCard />;
    let action = "success";

    const handleSendOtp = () => {
      VerifyCustomerOtp({ id }, onSuccessVerify, onErrorVerify);
      setIsModalOpen({ ...isModalOpen, show: false });
      onClose();
    };

    setIsModalOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: handleSendOtp,
      title: modalTitle,
      icon: modalIcon,
      type,
    });
  };

  const onSuccessVerify = (res) => {
    toast.success(res?.message);
    setShowEditOptPopup(true);
  };

  const onErrorVerify = (err) => {
    toast.error(err?.message || "Failed to delete record");
  };

  const handleOtpVerifiedEdit = (verifiedResponse) => {
    setVerifiedCardData(verifiedResponse);
    setShowEditOptPopup(false);
    setShowCardDetails(true);
  };

  useEffect(() => {
    if (show) {
      posthog.stopSessionRecording();
    } else {
      posthog.startSessionRecording();
    }
  }, [show]);

  return (
    <>
      {showCardDetails && (
        <CustomerCardEdit
          show={showCardDetails}
          onClose={() => setShowCardDetails(false)}
          formData={verifiedCardData}
        />
      )}

      <ComanConfirmationModal
        show={isModalOpen.show}
        onHide={() => setIsModalOpen({ ...isModalOpen, show: false })}
        title={isModalOpen.title}
        message={isModalOpen.message}
        onConfirm={isModalOpen.onConfirm}
        icon={isModalOpen.icon}
        type={isModalOpen.type}
      />

      {showEditOptPopup && (
        <OtpVerifyPopup
          show={showEditOptPopup}
          onClose={() => setShowEditOptPopup(false)}
          formData={Verified}
          onVerified={handleOtpVerifiedEdit}
        />
      )}

      {showOtpPopup && (
        <OtpVerficationPopup
          show={showOtpPopup}
          onClose={() => setShowOtpPopup(false)}
          formData={paymentData}
          paymentAmount={paymentAmount}
          opportunityId={opportunityId}
          onVerified={(response) => {
            handleOtpVerified();
            setShowOtpPopup(false);
            if (window.onPaymentSuccess) {
              window.onPaymentSuccess(response);
            }
          }}
        />
      )}

      <Modal show={show} onHide={onClose} size="xl">
        <Modal.Header
          className="gap-2 justify-content-between pe-5"
          closeButton
        >
          <div className="d-flex align-items-center gap-2">
            <span className="avatar bg-indigo-lt rounded-circle">
              <IconCreditCard />
            </span>
            <Modal.Title>Card Details</Modal.Title>
          </div>
          <div className="d-flex gap-2">
            <span
              className="add_new_card bg-indigo"
              variant="outline-primary"
              size="sm"
              onClick={() => {
                setAddCard(!addCard);
                setGetCard(false);
              }}
            >
              {addCard ? "Hide" : "Add Card"}
            </span>
            <span
              className="add_new_card bg-indigo"
              variant="outline-primary"
              size="sm"
              onClick={() => {
                setGetCard(!getCard);
                setAddCard(false);
              }}
            >
              {getCard ? "Hide" : "Get Card"}
            </span>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="table-responsive mail_wrapper p-0 border-0 mb-0 box-shadow-none">
            <Table className="table-bordered card-table">
              <thead>
                <tr>
                  <th>CARDHOLDER NAME</th>
                  <th>CARD NUMBER</th>
                  <th>CARD EXPIRY</th>
                  <th>INVOICE NUMBER</th>
                  <th>CREATED DATE</th>
                  <th>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {cardDetails.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No card details found.
                    </td>
                  </tr>
                ) : (
                  cardDetails.map((card) => (
                    <>
                      <tr key={card.id}>
                        <td>{card.info_name}</td>
                        <td>{"**** **** **** " + card.info_number}</td>
                        <td>{card.info_expiry}</td>
                        <td>{card.invoice_number || "N/A"}</td>
                        <td>{moment(card.created_at).format("MM/DD/YYYY")}</td>
                        <td className="d-flex gap-2">
                          <Button
                            className="w-auto"
                            style={{ minWidth: "auto" }}
                            onClick={() => handleOtp(card)}
                          >
                            Pay
                          </Button>
                          <Button
                            className="w-auto"
                            style={{ minWidth: "auto" }}
                            onClick={() => openModal(card?.id)}
                            disabled={!canEditCards}
                          >
                            View/Edit
                          </Button>
                        </td>
                      </tr>
                      <tr key={`note-${card.id}`}>
                        <td colSpan="6" className="text-end">
                          Notes: {card.note || "N/A"}
                        </td>
                      </tr>
                    </>
                  ))
                )}
              </tbody>
            </Table>
          </div>

          {/* Get Card Section */}
          {getCard && (
            <Card className="add_credit_card mb-3 mt-3">
              <Card.Header className="card_header">GET NEW CARD</Card.Header>
              <Card.Body>
                <Form onSubmit={handleGetCardSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label className="required">EMAIL</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={getCardDetails.email}
                      onChange={handleGetCardChange}
                      placeholder="Enter your email address"
                    />
                    {getCardErrors.email && (
                      <div className="text-danger">{getCardErrors.email}</div>
                    )}
                  </Form.Group>

                  <div className="d-flex justify-content-center gap-2">
                    <Button
                      type="submit"
                      variant="primary"
                      disabled={
                        isLoadingGetCard ||
                        getCardDetails.email.trim() === "" ||
                        getCardErrors.email
                      }
                    >
                      {isLoadingGetCard ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        "Get Card"
                      )}
                    </Button>
                    <Button
                      type="button"
                      variant="outline-secondary"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          )}

          {/* Add Card Section */}
          {addCard && (
            <Card className="add_credit_card mb-3 mt-3">
              <Card.Header className="card_header">ADD NEW CARD</Card.Header>
              <Card.Body>
                <Form onSubmit={handleAddCardSubmit}>
                  <Row>
                    {/* Cardholder Name */}
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="required">
                          CARDHOLDER NAME
                        </Form.Label>
                        <InputGroup>
                          <Form.Control
                            name="cardHolderName"
                            value={addCardData.cardHolderName}
                            onChange={handleAddCardChange}
                            placeholder="Enter Cardholder Name"
                            isInvalid={!!addCardErrors.cardHolderName}
                          />
                        </InputGroup>
                        {addCardErrors.cardHolderName && (
                          <div className="text-danger small">
                            {addCardErrors.cardHolderName}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* Card Number */}
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="required">
                          CARD NUMBER
                        </Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <IconBrandVisa stroke={1} />
                          </InputGroup.Text>
                          <Form.Control
                            name="cardNumber"
                            value={addCardData.cardNumber}
                            onChange={handleAddCardChange}
                            type="text"
                            placeholder="**** **** **** ****"
                            isInvalid={!!addCardErrors.cardNumber}
                          />
                        </InputGroup>
                        {addCardErrors.cardNumber && (
                          <div className="text-danger small">
                            {addCardErrors.cardNumber}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* Expiry */}
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label className="required">EXPIRY</Form.Label>
                        <InputGroup>
                          <Form.Control
                            name="expiry"
                            value={addCardData.expiry}
                            onChange={handleAddCardChange}
                            type="text"
                            placeholder="MM/YY"
                            maxLength={5}
                            isInvalid={!!addCardErrors.expiry}
                          />
                        </InputGroup>
                        {addCardErrors.expiry && (
                          <div className="text-danger small">
                            {addCardErrors.expiry}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* CVC */}
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label>CVC CODE</Form.Label>
                        <InputGroup>
                          <Form.Control
                            name="cvc"
                            value={addCardData.cvc}
                            onChange={handleAddCardChange}
                            type="password"
                            maxLength={4}
                            placeholder="123"
                            isInvalid={!!addCardErrors.cvc}
                          />
                        </InputGroup>
                        {addCardErrors.cvc && (
                          <div className="text-danger small">
                            {addCardErrors.cvc}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* ZIP Code */}
                    <Col md={4}>
                      <Form.Group className="mb-3">
                        <Form.Label className="required">ZIP CODE</Form.Label>
                        <Form.Control
                          name="zipCode"
                          value={addCardData.zipCode}
                          onChange={handleAddCardChange}
                          placeholder="90210"
                          isInvalid={!!addCardErrors.zipCode}
                        />
                        {addCardErrors.zipCode && (
                          <div className="text-danger small">
                            {addCardErrors.zipCode}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* Address */}
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>ADDRESS</Form.Label>
                        <InputGroup>
                          <Form.Control
                            name="address"
                            value={addCardData.address}
                            onChange={handleAddCardChange}
                            placeholder="Enter Address"
                          />
                        </InputGroup>
                      </Form.Group>
                    </Col>

                    {/* Invoice Number */}
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="required">
                          INVOICE NUMBER
                        </Form.Label>
                        <Form.Control
                          name="invoiceNumber"
                          value={addCardData.invoiceNumber}
                          onChange={handleAddCardChange}
                          disabled={true}
                          type="text"
                          placeholder="Enter Invoice Number"
                          isInvalid={!!addCardErrors.invoiceNumber}
                        />
                        {addCardErrors.invoiceNumber && (
                          <div className="text-danger small">
                            {addCardErrors.invoiceNumber}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* Amount */}
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="required">AMOUNT</Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <IconCurrencyDollar stroke={2} />
                          </InputGroup.Text>
                          <Form.Control
                            name="amount"
                            disabled={true}
                            value={addCardData.amount}
                            onChange={handleAddCardChange}
                            type="number"
                            step="0.01"
                            min="0"
                            placeholder="Enter Amount"
                            isInvalid={!!addCardErrors.amount}
                          />
                        </InputGroup>
                        {addCardErrors.amount && (
                          <div className="text-danger small">
                            {addCardErrors.amount}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* Notes */}
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>ADDITIONAL NOTES</Form.Label>
                        <Form.Control
                          name="notes"
                          value={addCardData.notes}
                          onChange={handleAddCardChange}
                          placeholder="Enter notes"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <div className="d-flex justify-content-center gap-2">
                    <Button
                      type="submit"
                      variant="warning"
                      disabled={
                        isLoadingAddCard ||
                        Object.values(addCardErrors).some(
                          (error) => error !== "",
                        ) ||
                        addCardData.cardHolderName.trim() === "" ||
                        addCardData.cardNumber.trim() === "" ||
                        addCardData.expiry.trim() === "" ||
                        addCardData.zipCode.trim() === "" ||
                        addCardData.invoiceNumber.trim() === "" ||
                        addCardData.amount.toString().trim() === ""
                      }
                    >
                      {isLoadingAddCard ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        "Submit"
                      )}
                    </Button>
                    <Button
                      type="button"
                      variant="outline-secondary"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default CardDetails;
